<template>
    <div v-e2e="'paralisar-form-wrapper'" class="paralisar-form-wrapper">
        <TrfHeader v-if="isPage" :pageTitle="pageTitle"/>
        <div v-e2e="'form-paralisar-tarefa'" class="form-paralisar-tarefa">
            <div class="columns mb-0">
                <div class="column pb-0 is-narrow is-flex is-align-items-center">
                    <label class="mb-0 mt-2">Informe a data de retorno para o controle {{ tarefa?.isFase? 'da fase' : tarefa?.isProcesso? 'do negócio' : 'da tarefa' }}:</label>
                </div>
                <div class="column is-narrow pb-0">
                    <input 
                        v-e2e="'form-paralisar-input-data'" 
                        class="input form-paralisar-input-data" 
                        type="date"
                        required 
                        @change="emitValueChange"
                    />
                    <p v-if="showValidation && !isFormatoValido" class="help is-danger " v-e2e="'form-paralisar-formato-invalido'">Formato de data inválido.</p>
                </div>
            </div>
            <div class="columns pb-0">
                <div class="column is-full">
                    <p v-if="showValidation && !isDataValida && isFormatoValido" class="help is-danger" v-e2e="'form-paralisar-data-invalida'">A data de retorno informada é menor ou igual à data atual, portanto não pode ser ajustada. Informe uma data válida para continuar.</p>
                </div>
            </div>
            <div class="columns">
                <div class="column is-full" v-e2e="'form-paralisar-comentario'">
                    <label>Comentário (Opcional):</label>
                    <TrfToolbarTextEditor
                        @changeText="updateComentario"
                        @ready="($event) => isToolbarTextEditorLoading = $event"
                        :maxlength="5000"
                        :tipLabel="tipLabelComentario"
                        ref="textEditorComentario"
                    />
                </div>
            </div>
            <div v-if="isPage" class="columns">
                <div class="column is-narrow">
                    <button class="button is-primary" :disabled="!isDataValida" @click="doAction" v-e2e="'form-paralisar-btn-confirmar'">Confirmar</button>
                </div>
                <div class="column is-narrow">
                    <button class="button" @click="doCancel" v-e2e="'form-paralisar-btn-cancelar'">Cancelar</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { ToastBuilder, toastTypeEnum } from '../../../builder/toast.builder';

export default {
  name: 'TrfParalisarFormComponent',
  emits: ['changed:value', 'error:input', 'done:action', 'done:cancel', 'error:save'],
  components: {
    TrfHeader: defineAsyncComponent(() => import('../../../components/Header/index.vue')),
    TrfToolbarTextEditor: defineAsyncComponent(() => import('../../../components/ToolbarTextEditor/index.vue'))
  },
  props: {
    dataBase: {
        type: Date || String,
        default: null
    },
    isPage: {
        type: Boolean,
        default: false
    },
    tarefa: {
        type: Object,
        default: () => {return {}}
    },
    customErrorOnSave: {
        type: Boolean,
        default: false
    }
  },
  data() {
    return {
        showValidation: false,
        dataValue: this.dataBase,
        comentario: '',
        isToolbarTextEditorLoading: true,
        comentarioLength: 0,
    };
  },
  computed: {
    isFormatoValido() {
         const regex = /^\d{4}-\d{2}-\d{2}$$/;
         
        return !(!regex.test(this.dataValue));
    },
    isDataValida() {
        const hoje = new Date()
        const data = !this.dataValue? hoje : new Date(this.dataValue)
        
        return data > hoje
    },
    isFase() {
        return this.tarefa?.isFase
    },
    isProcesso() {
        return this.tarefa?.isProcesso
    },
    pageTitle() {
        return this.tarefa?.isFase? 'Paralisar fase' : 'Paralisar Tarefa';
    },
    tipLabelComentario() {
        const caracteresRestantes = 5000 - this.comentarioLength;
        return `${caracteresRestantes} caracteres restantes`;
    }
  },
  methods: {
    async importService() {
        const { service } = await import('../service/historico-tarefas-service.js');
        return service
    },
    emitValueChange(event) {
        if (!event.target.value || (!!this.dataValue && !this.isFormatoValido)) {
            this.emitErrorInput()
            return;
        }
        this.showValidation = true
        this.dataValue = event.target.value
        this.$emit('changed:value', this.dataValue)
    },
    emitErrorInput() {
        this.showValidation = true
        this.dataValue = ''
        this.$emit('error:input', this.dataValue)
    },
    emitErrorSave(message) {
        this.$emit('error:save', message)
    },
    async doAction() {
        if (!this.tarefa || !this.isDataValida || !this.isFormatoValido) {
            this.showValidation = true
            this.emitErrorSave()
            return
        }
        
        try {
            const historicoTarefasService = await this.importService();
            const historicoId = (this.isFase || this.isProcesso) ? this.tarefa.historicoTarefaId : this.tarefa.id;
            const faseId = this.getFaseId();
            await historicoTarefasService.paralisarHistorico(historicoId, this.dataValue, faseId, this.isProcesso, this.comentario)
            this.showSuccess()
            this.$emit('done:action')
        } catch (e) {
            const message = e.message
            this.emitErrorSave(message)
            if(this.customErrorOnSave) return
            this.showError(message)
        }
    },
    getFaseId() {
        if (this.isFase) {
            if (this.tarefa?.processoId) {
                return this.tarefa.id;
                }
            return this.tarefa.faseId;
        }
    },
    async doCancel() {
        this.showValidation = false;
        this.clearInputAndStatus()
        await this.$nextTick()
        this.$emit('done:cancel')
    },
    updateComentario(value) {
        this.comentario = value;
        if (this.$refs.textEditorComentario) {
            this.comentarioLength = this.$refs.textEditorComentario.getValueAsText().length;
        }
    },
    clearInputAndStatus() {
        this.$el.querySelector('input.form-paralisar-input-data').value = ''; // Necessário para remover preenchimento parcial no input
        this.dataValue = ''; // Garante que a parte lógica do vue foi atualizada
        this.comentarioLength = 0; // Reseta o contador
        if (this.$refs.textEditorComentario) {
            this.$refs.textEditorComentario.limparCampo();
        }
        this.$emit('changed:value', null)
    },
    showError(message = `Não foi possível paralisar esta ${this.isFase? 'fase' : 'tarefa'} no momento.`) {
        const toast = new ToastBuilder();
        toast.setType(toastTypeEnum.DANGER)
        toast.setMessage(message)
        toast.toast();
    },
    showSuccess() {
        const toast = new ToastBuilder();
        toast.setType(toastTypeEnum.SUCCESS)
        toast.setMessage(`${this.isFase? 'Fase paralisada' : this.isProcesso? 'Negócio paralisado' :'Tarefa paralisada'} com sucesso!`)
        toast.toast();
    },
    
  }
};
</script>
